import React from 'react'
import { useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'

export default function BottomMenu() {

  const [hiddenMenu, setHidden] = useState(false)

  

  return (
    <div className='bottom-menu' 
          style={{zIndex: useLocation().pathname == '/work' ? '2' : '1', display: useLocation().pathname[1] == "d" ? 'none' : 'flex'}}>
        <Link to='/skills'>
            <button style={{color: useLocation().pathname == '/skills' ? '#fff' : 'rgb(142, 142, 142)' }}>Skills</button>
        </Link>
        <Link to='/' >
            <button style={{color: useLocation().pathname == '/' ? '#fff' : 'rgb(142, 142, 142)' }}>Home</button>
        </Link>
        <Link to='/work' >
            <button style={{color: useLocation().pathname == '/work' ? '#fff' : 'rgb(142, 142, 142)' }}>Works</button>
        </Link>
    </div>
  )
}
